/**
 * @generated SignedSource<<544f577cbb0c89811910853b270d00ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getInitialDatasetsValuesQuery$variables = {
  property_id: number;
};
export type getInitialDatasetsValuesQuery$data = {
  readonly sys_properties_flattened_union: ReadonlyArray<{
    readonly investment_properties_dataset_validation_rules: ReadonlyArray<{
      readonly dataset_validation_rule_id: number;
      readonly validation_mode: string;
    }>;
    readonly properties_batch_validation_rules: ReadonlyArray<{
      readonly batch_validation_rule_id: number;
      readonly validation_mode: string;
    }>;
    readonly properties_dataset_validation_rules: ReadonlyArray<{
      readonly dataset_validation_rule_id: number;
      readonly validation_mode: string;
    }>;
    readonly properties_datasets: ReadonlyArray<{
      readonly dataset_id: number;
    }>;
  }>;
};
export type getInitialDatasetsValuesQuery = {
  response: getInitialDatasetsValuesQuery$data;
  variables: getInitialDatasetsValuesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_id"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "is_active": {
        "_eq": true
      }
    }
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validation_mode",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataset_validation_rule_id",
    "storageKey": null
  },
  (v2/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "property_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_properties_flattened_union",
    "kind": "LinkedField",
    "name": "sys_properties_flattened_union",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "sys_properties_batch_validation_rules",
        "kind": "LinkedField",
        "name": "properties_batch_validation_rules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "batch_validation_rule_id",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": "properties_batch_validation_rules(where:{\"is_active\":{\"_eq\":true}})"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "sys_properties_dataset_validation_rules",
        "kind": "LinkedField",
        "name": "properties_dataset_validation_rules",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "properties_dataset_validation_rules(where:{\"is_active\":{\"_eq\":true}})"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "sys_properties_dataset_validation_rules",
        "kind": "LinkedField",
        "name": "investment_properties_dataset_validation_rules",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "investment_properties_dataset_validation_rules(where:{\"is_active\":{\"_eq\":true}})"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "sys_properties_datasets",
        "kind": "LinkedField",
        "name": "properties_datasets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataset_id",
            "storageKey": null
          }
        ],
        "storageKey": "properties_datasets(where:{\"is_active\":{\"_eq\":true}})"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getInitialDatasetsValuesQuery",
    "selections": (v4/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getInitialDatasetsValuesQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "17024841acbe27cb085c6957d7da9960",
    "id": null,
    "metadata": {},
    "name": "getInitialDatasetsValuesQuery",
    "operationKind": "query",
    "text": "query getInitialDatasetsValuesQuery(\n  $property_id: Int!\n) {\n  sys_properties_flattened_union(where: {property_id: {_eq: $property_id}}) {\n    properties_batch_validation_rules(where: {is_active: {_eq: true}}) {\n      batch_validation_rule_id\n      validation_mode\n    }\n    properties_dataset_validation_rules(where: {is_active: {_eq: true}}) {\n      dataset_validation_rule_id\n      validation_mode\n    }\n    investment_properties_dataset_validation_rules(where: {is_active: {_eq: true}}) {\n      dataset_validation_rule_id\n      validation_mode\n    }\n    properties_datasets(where: {is_active: {_eq: true}}) {\n      dataset_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a878a4479a10c4a63b4be16929c659d";

export default node;
